import { getURL } from "shelving";
import { LEAVE_GROUP } from "shared/api";
import { Confirm, CopyButton, Icon, ModalButton, PathButton, useNavigator } from "shared/react";
import { NON_MEMBER, getGroupPath, getGroupTag, isApprovedMember, isOwnerMember } from "shared/schema";
import { CreatorMenu } from "../create/CreatorMenu.js";
import { callAPIWithNotice } from "../util/api.js";
import { useMemberItem } from "../util/data.js";
import { useItem } from "../util/db.js";

export function GroupMenu({ gid }: { gid: string }): React.ReactElement | null {
	const group = useItem("group", gid).data;
	const { verified } = group;
	const { status } = useMemberItem(gid).value || NON_MEMBER;
	const path = getGroupPath(group);
	const tag = getGroupTag(group);
	const nav = useNavigator();
	return (
		<>
			<nav className="flex-column gap-hairline">
				<h2 className="label">Group</h2>
				<PathButton path={`${path}/messages`}>
					<Icon icon="chat" /> <span>Messages</span>
				</PathButton>
				<PathButton path={`${path}/about`}>
					<Icon icon="info" /> <span>About</span>
				</PathButton>
				{isApprovedMember(status) ? (
					<>
						<PathButton path={`${path}/assigned`}>
							<Icon icon="challenge" /> <span>Assigned challenges</span>
						</PathButton>
						<PathButton path={`${path}/leaderboards`}>
							<Icon icon="leaderboard" /> <span>Joined leaderboards</span>
						</PathButton>
					</>
				) : null}
			</nav>
			<CreatorMenu path={path} verified={verified} />
			<nav className="flex-column gap-hairline">
				<PathButton path={`${path}/members`}>Members</PathButton>
				<PathButton path={`${path}/invite`}>Invite</PathButton>
				{isOwnerMember(status) ? (
					<PathButton path={`${path}/settings`}>Settings</PathButton>
				) : isApprovedMember(status) ? (
					<ModalButton
						mods="confirm"
						modal={
							<>
								<p>
									<strong>Are you sure you wish to leave this group?</strong>
								</p>
								<ul>
									<li>Any messages you have posted in this group will be permanently deleted.</li>
									<li>To rejoin you will need to be reinvited and approved by a group admin.</li>
								</ul>
								<Confirm
									onConfirm={async () => {
										await callAPIWithNotice(LEAVE_GROUP, gid);
										nav.redirect("/groups");
									}}
								/>
							</>
						}
					>
						Leave group
					</ModalButton>
				) : null}
			</nav>
			<nav className="flex-row flex-stretch gap-hairline">
				<CopyButton copy={tag}>Copy tag</CopyButton>
				<CopyButton copy={getURL(path).href}>Copy link</CopyButton>
			</nav>
		</>
	);
}
